import React from 'react';
import { Box, Typography, Stack, List, ListItem, ListItemText, Card } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

function About({ requirements, certificateEnabled, instructor }) {
    return (
        <Box>
            <Card
                sx={{
                    p: 2,
                    border: '1px solid #ddd',
                    boxShadow: 'none',
                    borderRadius: 2,
                    backgroundColor: '#fff', // Clean white background
                }}
            >
                {/* About the Course */}
                {/* <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
                        About the Course
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#555' }}>
                        {description}
                    </Typography>
                </Box> */}

                {/* Requirements */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
                        Requirements
                    </Typography>
                    <List>
                        {requirements.map((req, index) => (
                            <ListItem key={index} sx={{ pl: 0 }}>
                                <CircleIcon sx={{ color: 'primary.main', mr: 2, fontSize: '0.5rem' }} />
                                <ListItemText primary={req} sx={{ color: '#555' }} />
                            </ListItem>
                        ))}
                    </List>
                </Box>

                {/* Certificate */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
                        Certificate
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#555', mb: 2 }}>
                        {certificateEnabled
                            ? 'Complete this course to earn a certificate of completion, showcasing your achievements.'
                            : 'This course does not provide a certificate of completion.'}
                    </Typography>

                    {/* Show certificate image if certificate is supported */}
                    {certificateEnabled && (
                        <Box
                            component="img"
                            src="https://cloudsecnetwork.s3.us-east-1.amazonaws.com/public/sample-cert.png"
                            alt="Certificate of Completion"
                            sx={{
                                width: '100%',
                                maxWidth: '240px', // Limit the maximum width of the image
                                borderRadius: 2, // Slight rounding for a polished look
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // Add shadow for depth
                            }}
                        />
                    )}
                </Box>

                {/* Instructor */}
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
                        Instructor
                    </Typography>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Box
                            component="img"
                            src={instructor.profilePic}
                            alt={instructor.name}
                            sx={{
                                width: 80,
                                height: 80,
                                borderRadius: '50%',
                                objectFit: 'cover',
                            }}
                        />
                        <Box>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#333' }}>
                                {instructor.name}
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                                {instructor.role}
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#555' }}>
                                {instructor.bio}
                            </Typography>
                        </Box>
                    </Stack>
                </Box>
            </Card>
        </Box >
    );
}

export default About;
